/**
 * Node Modules
 */
import React, {createElement} from 'react'

/**
 * Application Modules
 */
import './style.css'
import '../../../components/styles/buttons.css'
import Section from '../../../components/section'
import Spacer from '../../../components/spacer'
import marksy from 'marksy/jsx'

const compile = marksy({createElement})

/**
 * Component
 */
export default function Hero({ hed, dek }) {

  return (
    <Section className="story-hero">
      <div className="story-hero__grid grid">
        <div className="column-start-1 column-end-6 column-start-2--t column-end-11--t  column-start-3--d column-end-10--d">
          <Spacer size={[50, 100]} />
            <h1 className="our-values-hero__hed column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
              {hed}
            </h1>
            <Spacer size={[10, 40]} />
            <p className="our-values-hero__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
              {compile(dek).tree}
            </p>
          <Spacer size={[48, 32]} />
        </div>
      </div>
    </Section>
  )
}
